import { cloneElement, type ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import DialogActions from '../DialogActions';
import Button, { type ButtonProps } from '@/components/Button';
import { CheckIcon } from '@/icons';
import { classes } from './utils';

export type DefaultDialogActionsProps = {
  confirmLabel?: string;
  pendingLabel?: string;
  cancelLabel?: string;
  skipLabel?: string;
  confirmEnabled?: boolean;
  pending?: boolean;
  disabled?: boolean;
  onConfirm: ButtonProps['onClick'];
  onSkip?: ButtonProps['onClick'];
  onCancel: () => void;
  confirmIcon?: ReactElement;
  className?: string;
};

export default function DefaultDialogActions({
  confirmLabel = 'Confirm',
  pendingLabel = 'Sending...',
  cancelLabel = 'Cancel',
  skipLabel = 'Skip',
  pending,
  disabled,
  onConfirm,
  onSkip,
  onCancel,
  confirmIcon,
  className = '',
  ...props
}: DefaultDialogActionsProps) {
  const renderIcon = () => {
    return confirmIcon ? (
      cloneElement(confirmIcon, { className: classes.icon })
    ) : (
      <CheckIcon className={classes.icon} />
    );
  };

  return (
    <DialogActions className={className} {...props}>
      <Button
        variant="text"
        disabled={pending}
        className={classes.button}
        textClasses={classes.cancel}
        // tabIndex={-1}
        onClick={onCancel}>
        {cancelLabel}
      </Button>
      <div>
        {onSkip && (
          <Button
            variant="text"
            disabled={pending}
            className={twMerge(classes.button, classes.skipButton)}
            textClasses={classes.skip}
            onClick={onSkip}>
            {skipLabel}
          </Button>
        )}
        <Button
          disabled={disabled || pending}
          className={classes.button}
          onClick={onConfirm}>
          {pending ? null : renderIcon()}
          {pending ? pendingLabel : confirmLabel}
        </Button>
      </div>
    </DialogActions>
  );
}
